<template>
  <div>
    <cube-form
      :model="model"
      :options="options"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
    >
      <cube-form-item :field="fields[0]" />
      <div class="cube-form-item-box">
        <cube-form-item :field="fields[1]" />
        <div class="find-pwd-box">
          <router-link :to="{name: 'AccountFindPwd'}">
            {{ $t('message["1573"]') }}
          </router-link>
        </div>
      </div>
      <cube-form-group>
        <cube-button
          type="submit"
          :primary="true"
        >
          {{ $t('message["196"]') }}
        </cube-button>
      </cube-form-group>
    </cube-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import loginMin from '@/store/account/loginMin'
export default {
  mixins: [loginMin],
  data () {
    return {
      options: {
        scrollToInvalidField: true,
        layout: 'classic' // classic fresh
      },
      validity: {},
      valid: undefined,
      model: {
        username: '',
        password: ''
      },
      fields: [
        {
          type: 'input',
          modelKey: 'username',
          label: '',
          props: {
            placeholder: this.$t('message["203"]')
          },
          rules: {
            custom: (val) => {
              if (val) {
                return true
              } else {
                return false
              }
            }
          },
          messages: {
            // required: '请输入会员名/手机/邮箱',
            custom: this.$t('message["764"]')
          }
        },
        {
          type: 'input',
          modelKey: 'password',
          label: '',
          props: {
            placeholder: this.$t('message["198"]'),
            type: 'password'
          },
          rules: {
            // required: true,
            custom: (val) => {
              if (val) {
                return true
              } else {
                return false
              }
            }
          },
          messages: {
            // required: '请输入密码',
            custom: this.$t('message["762"]')
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('account/login', ['submitting', 'decorators'])
  },
  mounted () {
  },
  methods: {
    ...mapActions('account/login', ['login', 'toOrgProject']),
    async submitHandler (e) {
      setTimeout(async () => {
        const obj = Object.assign(this.model, { logintype: 1 })
        const chain = await this.login()
        chain.params(obj)
          .onSuccess(async (raw) => {
            const chain2 = await this.toOrgProject()
            chain2.onSuccess(res => {
              this.getOrgPro(res)
            })
          })
          .onNetSuccess((res) => {
            const error = res.data.error
            if (!error) {
              this.$selefToast({ text: res.data.message })
            } else {
              this.$selefToast({ type: 'error', text: res.data.message || res.data.payload[0].message })
            }
          })
          .setForm(this.form)
          .fetch()
      }, 1000)
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    }
  }
}
</script>
